import React, { useRef, useState } from "react";
import { Form, Input } from "semantic-ui-react";
import { Box, Button, CircularProgress, Typography, Alert, FormControlLabel, Checkbox } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import customHttp from "../../services/customHTTP";
import { useAuth } from "../../context/authContext";
import "./AcceptEULA.css";
import { ASSETS_BASE_URL } from "../../config";

const AcceptEULA = () => {
	const [eulaChecked, setEulaChecked] = useState(false);
	const [eulaRead, setEulaRead] = useState(false);
	const [loading, setLoading] = useState(false);
	const { user, updateUserStatus } = useAuth();
	const navigate = useNavigate();

	const AuthPageStyles = {
		backgroundImage: `url('${ASSETS_BASE_URL}/home_bg2.jpg')`,
		backgroundSize: "cover",
		backgroundPosition: "center",
	};

	const handleAcceptEULA = async () => {
		setLoading(true);
		try {
			const response = await customHttp.post("/auth/eula-accept", {
				user_id: user.user_id,
				eula_accepted: eulaChecked,
			});
			if (response.status === 200) {
				setLoading(false);
				updateUserStatus({ eula_accepted: true, eula_accepted_date: new Date() });
				navigate("/home");
			}
		} catch (error) {
			console.error("Error accepting EULA:", error);
		}
	};

	return (
		<Box className="login-container" sx={AuthPageStyles}>
			<Box className="login-form-container" sx={{ maxWidth: "65vw !important", width: "60vw !important" }}>
				<div className="form-container" sx={{ paddingTop: "20px" }}>
					<PageTitle title="End User License Agreement" />

					<Form className="login-form">
						<Box
							sx={{
								minHeight: "300px",
								overflowY: "auto",
								border: "1px solid #ccc",
							}}>
							<iframe
								src={`${ASSETS_BASE_URL}/Legal/End-User%20License%20Agreement%20(EULA).pdf`}
								width="100%"
								height="450px"
								style={{ border: "none" }}
								title="EULA"></iframe>
						</Box>
						<Box mt={2} textAlign="center">
							<FormControlLabel
								control={
									<Checkbox
										checked={eulaChecked}
										onChange={(e) => setEulaChecked(e.target.checked)}
									/>
								}
								label="I have read and agree to the End User License Agreement (EULA)"
							/>
						</Box>
						<Box mb={2}>
							<Typography variant="body1" textAlign="center">
								By clicking the button below, you agree to the following EULA:
							</Typography>
						</Box>
						<div className="login-button">
							<Button
								variant="contained"
								color="primary"
								className="button-primary"
								type="submit"
								sx={{
									minWidth: "120px",
									backgroundColor: loading || !eulaChecked ? "#ddd !important" : "primary.main",
									"&:hover": {
										backgroundColor: loading || !eulaChecked ? "#ddd !important" : "primary.dark",
									},
								}}
								onClick={handleAcceptEULA}
								disabled={loading || !eulaChecked}>
								{loading ? "Submitting..." : "Accept"}
							</Button>
						</div>
					</Form>
				</div>
			</Box>
		</Box>
	);
};

export default AcceptEULA;
